import { render } from "./SurnameFilter.vue?vue&type=template&id=1d196c0a&scoped=true"
import script from "./SurnameFilter.vue?vue&type=script&lang=js"
export * from "./SurnameFilter.vue?vue&type=script&lang=js"

import "./SurnameFilter.vue?vue&type=style&index=0&id=1d196c0a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d196c0a"]])

export default __exports__